import { render, staticRenderFns } from "./StickySearchTagList.vue?vue&type=template&id=f24f8582&scoped=true&"
import script from "./StickySearchTagList.vue?vue&type=script&lang=js&"
export * from "./StickySearchTagList.vue?vue&type=script&lang=js&"
import style0 from "./StickySearchTagList.vue?vue&type=style&index=0&id=f24f8582&lang=scss&scoped=true&"
import style1 from "./StickySearchTagList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24f8582",
  null
  
)

export default component.exports